import type { dash, dcs } from "@dropbox/api-v2-client";
import type {
  ChatSource,
  ChatSourceDashSearchResult,
} from "@mirage/mosaics/Chat/types";

/**
 * Converts LinkMetadata results from dcsGetLinkMetadata to ChatSource objects
 * @param results The results from dcsGetLinkMetadata API call
 * @returns Array of ChatSource objects
 */
export function convertLinkMetadataToChatSources(
  results: dcs.GetLinkMetadataResponse["results"],
): ChatSource[] {
  if (!results || results.length === 0) {
    return [];
  }

  return results.map((result): ChatSource => {
    const searchResult: dcs.query_result_unionSearchResult = {
      ".tag": "search_result",
      uuid: result.uuid ?? "",
      title: result.title ?? "",
      url: result.link ?? "",
      connector_info: result.connector_info,
      file_type_info: result.file_type_info,
      provider_updated_at_ms: result.last_modified_time
        ? new Date(result.last_modified_time).getTime()
        : 0,
      summarizable: result.summarizable,
      answerable: result.answerable,
      preview_url: result.preview_url,
      branded_type: result.branded_type,
      record_type: {
        ".tag": "unknown_record_type",
      } as dash.RecordType,
      body:
        result.body?.blob_content &&
        result.body.blob_content[".tag"] === "raw_content"
          ? result.body.blob_content.raw
          : "",
    };

    const dashSource: ChatSourceDashSearchResult = {
      type: "dash_search_result",
      searchResult,
    };
    return dashSource;
  });
}
